import * as React from 'react';
import { CheckinSegmentFragment } from '@websky/graphql';
import { CheckoutSegmentProps, SelectableCheckoutSegment } from './SelectableSegment';

type CheckinSegmentProps = Pick<
	CheckoutSegmentProps,
	'parentFlight' | 'index' | 'highlight' | 'transferInfo' | 'showStopsInfo'
> & {
	segment: CheckinSegmentFragment;
};

export const SelectableCheckinSegment: React.FC<CheckinSegmentProps> = props => {
	const checkinFlight = props.segment as CheckinSegmentFragment;

	return (
		<SelectableCheckoutSegment
			index={props.index}
			highlight={props.highlight}
			showStopsInfo={props.showStopsInfo}
			transferInfo={props.transferInfo}
			parentFlight={props.parentFlight}
			segment={{
				aircraft: checkinFlight.aircraft,
				duration: checkinFlight.duration,
				flightNumber: checkinFlight.flightNumber,
				operatingAirline: checkinFlight.operatingAirline,
				marketingAirline: checkinFlight.marketingAirline,
				departure: checkinFlight.departure,
				arrival: checkinFlight.arrival,
				stops: checkinFlight.stops,
				messages: []
			}}
		/>
	);
};
